<div class="grid-2col input-grid-gaps">
    @if (contractId === null) {
        <app-select-input [formField]="formDef.contractId" [staticOptions]="contractOptions" [label]="prefix + 'service'"></app-select-input>
    }
    <app-number-input [formField]="formDef.percentage" [maxFractionDigits]="2" [label]="prefix + 'discountPercentage'"></app-number-input>
    <app-date-input [formField]="formDef.validFrom" [label]="prefix + 'validFrom'"></app-date-input>
    <app-date-input [formField]="formDef.validTo" [showClear]="true" [label]="prefix + 'validTo'"></app-date-input>
</div>
